import { createSelector } from '@reduxjs/toolkit'
import { type NotificationsState, storeKey } from '@shared-core/features/notifications/slice'
import type { AppState } from '@shared-core/store/types'

const selectNotificationsState = (state: AppState): NotificationsState => state[storeKey]

export const selectedToasts = createSelector(selectNotificationsState, (state) => state.toasts)

export const selectedServiceIsUnavailable = createSelector(
  selectNotificationsState,
  (state) => state.serviceIsUnavailable,
)

export const selectedIsServiceSheetOpen = createSelector(selectNotificationsState, (state) => state.isServiceSheetOpen)

export const selectedSbpPrepareError = createSelector(selectNotificationsState, (state) => state.sbpPrepareError)
export const selectedAntifraudPrepareError = createSelector(
  selectNotificationsState,
  (state) => state.antifraudPrepareError,
)

export const selectedIsInvalidToken = createSelector(selectNotificationsState, (state) => state.invalidToken)

export const selectedIsKycRequired = createSelector(selectNotificationsState, (state) => state.KYC2IsRequired)

export const selectedTelegramAlreadyLinkedToAnotherAccount = createSelector(
  selectNotificationsState,
  (state) => state.telegramAlreadyLinkedToAnotherAccount,
)
